import { apiCheckLogin, apiRefreshToken, apiUpdateDefultWithData } from '@/api/user.js'
import { apiGetContainers } from '@/api/optimize.js'

export const checkUserLogin = async () => {
  try {
    const res = await apiCheckLogin()
    if (res.status === 200) {
      const container_config = JSON.parse(sessionStorage.getItem('container_config_status')) || {}
      const cache_map_update_at = JSON.parse(res.headers['cache-map-update-at'])
      for (const [key, item] of Object.entries(cache_map_update_at)) {
        if (container_config[key] !== item) {
          sessionStorage.setItem(`${key.toLowerCase()}_is_change`, 'true')
        }
      }
      sessionStorage.setItem('container_config_status', JSON.stringify(cache_map_update_at))

      return res.data.data
    }
    throw new Error('取得資料失敗')
  } catch (error) {
    console.log('checkUserLogin() :', error)
    return null
  }
}

export const initOrganizeMapper = async (user_data) => {
  let user_info_container = []
  if (user_data.container_user_enabled.container) {
    user_data.container_user_enabled.container.forEach((container) => {
      user_info_container.push(container.id)
    })
  }
  let account_organizations = user_data.organizations

  // 取所有org對應的container
  let organize_container_mapper = {}
  for (let idx = 0; idx < account_organizations.length; idx++) {
    let account_organization = account_organizations[idx]

    let containers = await apiGetContainers(account_organization.org_id)
      .then((resp) => {
        return resp.data.data
      })
      .catch(() => {
        return []
      })
    // beta user什麼都看得到
    if (!user_data.is_beta_user) {
      // 如果有找到，代表有限制過可看到的容器，沒有找到預設就是全開
      let is_container_user = user_data.container_user_enabled.enabled_status.find((enabled_status) => {
        return enabled_status.userAuthId.orgId === account_organization.org_id && enabled_status.enable
      })
      if (is_container_user) {
        containers = containers.filter((container) => {
          return user_info_container.includes(container.id)
        })
      }
    }

    organize_container_mapper[account_organization.org_id] = {
      organization: account_organization,
      containers: containers,
    }
  }

  if (Object.keys(organize_container_mapper).length === 0) {
    return null
  } else {
    return organize_container_mapper
  }
}

export const refreshToken = async () => {
  let result = null

  result = await apiRefreshToken()
    .then((resp) => {
      return resp.data.data
    })
    .catch((error) => {
      console.error('refresh_token_error', error)
      return false
    })

  return result
}

export const updateLastSeen = async (params) => {
  try {
    let payload = {
      default_value: params,
    }
    await apiUpdateDefultWithData(payload)
  } catch (error) {
    console.error('error', error)
  }
}
